<script setup lang="ts">
defineProps<{
  name: string
  id: string
}>()
</script>

<template>
  <GAList :id="id" :name="name" entity="carouselProductRails">
    <slot />
  </GAList>
</template>
